<template>
  <div class="card w-100">
    <div class="card-body">
      <h5 class="card-title">{{ t("moneyLabel") }}</h5>
      <div class="table-responsive">
        <table class="table cash-totals-table">
          <tbody>
            <tr>
              <td>{{ t("moneyLabel") }}</td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(summary.totalAssetsValue, currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="label-with-sign-icon">
                  {{ t("inSettlementLabel") }}
                  <img :src="minusIcon" class="sign-icon" alt="-" />
                </span>
              </td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(absoluteAmount(summary.totalBuySettlementAmount), currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="label-with-sign-icon">
                  {{ t("inSettlementLabel") }}
                  <img :src="plusIcon" class="sign-icon" alt="+" />
                </span>
              </td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(summary.totalSellSettlementAmount, currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
            <tr>
              <td>{{ t("freeFundsLabel") }}</td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(summary.freeFunds, currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
            <tr>
              <td>
                <span class="label-with-sign-icon">
                  {{ t("guaranteeDepositLabel") }}
                  <img :src="minusIcon" class="sign-icon" alt="-" />
                </span>
              </td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(summary.guaranteeDeposit, currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
            <tr>
              <td>{{ t("excessFundsLabel") }}</td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(summary.excessFunds, currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
            <tr>
              <td>{{ t("availableToWithdrawLabel") }}</td>
              <td class="equity_align_right_heavy">
                {{ formatPrice(summary.availableToWithdraw, currency, 2).replace(" ", "&nbsp;") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import minusIcon from "@/assets/images/Circle-plus-1.svg";
import plusIcon from "@/assets/images/Circle-plus.svg";

export default {
  name: "WalletCashTotalsCard",
  data() {
    return {
      minusIcon,
      plusIcon
    };
  },
  props: {
    summary: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    translator: {
      type: Function,
      required: true
    },
    priceFormatter: {
      type: Function,
      required: true
    }
  },
  methods: {
    t(key, ...args) {
      return this.translator(key, ...args);
    },
    formatPrice(...args) {
      return this.priceFormatter(...args);
    },
    absoluteAmount(amount) {
      return Math.abs(parseFloat(amount));
    }
  }
};
</script>

<style scoped>
.equity_align_right_heavy {
  font-weight: bold;
  text-align: right;
}

.cash-totals-table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.6rem 0.5rem;
}

.label-with-sign-icon {
  align-items: center;
  display: inline-flex;
  gap: 0.15rem;
  line-height: inherit;
}

.sign-icon {
  display: block;
  flex: 0 0 14px;
  height: 14px;
  transform: translateY(-2px);
  width: 14px;
}
</style>
